
import React from "react";
import { Check, X } from "lucide-react";
import { PlanFeature } from "@/types/subscription";

interface PlanFeaturesProps {
  features: PlanFeature[];
}

export const PlanFeatures: React.FC<PlanFeaturesProps> = ({ features }) => {
  return (
    <ul className="space-y-3">
      {features.map((feature, index) => (
        <li key={index} className="flex items-start">
          {feature.included ? (
            <Check className="h-5 w-5 text-green-500 mr-2 flex-shrink-0" />
          ) : (
            <X className="h-5 w-5 text-gray-300 mr-2 flex-shrink-0" />
          )}
          <span className={feature.included ? "" : "text-gray-400"}>
            {feature.name}
          </span>
        </li>
      ))}
    </ul>
  );
};
